module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHyAjHyBgXl/Ozs/m5+hNqsnHAAAACHRSTlMAYL//ACDP71kzCuAAAAB9SURBVEjH7daxEUBAFIThrYEKjAq4gAIeFRgVUIESZEq4CtxVKb6Z422K98dfvgugcI9VIpDZKa2CYdNQN2F0agtKHTWoddTCEb0d9T5mCnuCjpjtTJDPo5CgeJMhQ4YMGfobomaDGiBqyr665tShoa4RdbKou0YdPxH9Ql7MWRv7Jo4FogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f532.png
// module id = 1125
// module chunks = 0